import { type FC, type ReactNode } from "react";

import { Checkbox } from "./checkbox";

export type SourceOption = {
  value: string;
  label: string;
  hint?: string;
  checked: boolean;
};

// A Drafting section's sources as checkboxes, and anything under them (e.g.
// which supporting document).
export const SourceChecklist: FC<{
  options: SourceOption[];
  onToggle(value: string): void;
  disabled?: boolean;
  extra?: ReactNode;
}> = ({ options, onToggle, disabled, extra }) => (
  <div className="space-y-2">
    {options.map((option) => (
      <label
        key={option.value}
        className="flex items-center gap-2 text-[12.5px] text-slate-700"
      >
        <Checkbox
          checked={option.checked}
          disabled={disabled}
          onChange={() => onToggle(option.value)}
        />
        {option.label}
        {option.hint && <span className="text-slate-400">· {option.hint}</span>}
      </label>
    ))}
    {extra}
  </div>
);
